import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition, query, stagger, keyframes, state } from '@angular/animations';
import { CommonService } from "../common.service";
import { ApiService} from "../api.service";

declare var $ :any;

@Component({
  selector: 'app-case-practice-team-question',
  animations: [
    trigger(
    'casePracticeTeamQuestionAnimation', [
      transition('* => *', [
        query('div.casePracticeTeamQuestion', style({opacity: 0})),
        // query('img#videoShortCut', animate('1s', keyframes([
        //   style({opacity: 1, transform: 'translate(0%, 0%) scale(10, 10)'}),
        //   style({opacity: 0.8, transform: 'translate(20%, -20%) scale(8, 8)'}),
        //   style({opacity: 0.6, transform: 'translate(40%, -40%) scale(6, 6)'}),
        //   style({opacity: 0.4, transform: 'translate(60%, -60%) scale(4, 4)'}),
        //   style({opacity: 0.2, transform: 'translate(80%, -80%) scale(2, 2)'}),
        //   style({opacity: 0, transform: 'translate(100%, -100%) scale(0, 0)'})
        // ]))),
        query('div.casePracticeTeamQuestion', stagger('200ms', [animate('200ms', style({opacity: 1}))]))
      ]),
      transition(':leave', animate('0.2s', keyframes([
        style({opacity: 1, transform: 'translate(100%, 0%) scale(1)'}),
        style({opacity: 0.67, transform: 'translate(75%, 25%) scale(0.75)'}),
        style({opacity: 0.33, transform: 'translate(50%, 50%) scale(0.5)'}),
        style({opacity: 0.1, transform: 'translate(0%, 100%) scale(0.25)'})
      ])))
    ],
  ),
  trigger('questionShowAnimation', [
    state('showQuestion', style({transform: 'translate(0%)', opacity: 1})),
    state('hideQuestion', style({transform: 'translate(-100%)', opacity: 0})),
    transition('hideQuestion => showQuestion', animate('500ms', keyframes([
      style({transform: 'translate(100%)', opacity: 1}),
      style({transform: 'translate(80%)', opacity: 1}),
      style({transform: 'translate(60%)', opacity: 1}),
      style({transform: 'translate(40%)', opacity: 1}),
      style({transform: 'translate(20%)', opacity: 1}),
      style({transform: 'translate(0%)', opacity: 1}),
    ]))),
    transition('showQuestion => hideQuestion', animate('500ms', keyframes([
      style({transform: 'translate(0%)', opacity: 1}),
      style({transform: 'translate(-20%)', opacity: 1}),
      style({transform: 'translate(-40%)', opacity: 1}),
      style({transform: 'translate(-60%)', opacity: 1}),
      style({transform: 'translate(-80%)', opacity: 1}),
      style({transform: 'translate(-100%)', opacity: 1}),
    ])))
  ]),
  trigger('correctShowAnimation', [
    state('showCorrect', style({opacity: 0})),
    state('hideCorrect', style({opacity: 0})),
    transition('hideCorrect => showCorrect', animate('.5s', keyframes([
      style({opacity: 1, transform: 'scale(.5)'}),
      style({opacity: 0, transform: 'scale(1.5)'})
    ]))),
  ])],
  templateUrl: './case-practice-team-question.component.html',
  styleUrls: ['./case-practice-team-question.component.css',]
})
export class CasePracticeTeamQuestionComponent implements OnInit, AfterViewInit {

    @Output() onGoToBegin = new EventEmitter<any>();
    @Output() onGoToVideo = new EventEmitter<any>();

  questions: any;
  currentNumber: number;
  recordArray: any;
  optionArray: any;
  selectable: boolean;
  correctShow: boolean;
  questionShow: boolean;
  assetsRoute: string = "../../assets";

  constructor(private commonService:CommonService,
                private apiService:ApiService) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
    this.recordArray = [0,0,0,0,0];
    this.optionArray = ['信任','承诺','沟通','流程','结果'];
    this.selectable = true;
    this.correctShow = false;
    this.apiService.ajax({
      'type':'get',
      'url':'/api/diagnosis',
      'data':{}
    }).subscribe(result=>{

      this.questions = result.questions;
      this.currentNumber = result.number == result.questions.length ? result.number : result.number + 1;
      if(this.currentNumber == result.questions.length){

        this.selectable = false;
        // this.questionShow = false;
        setTimeout(function(){

          // $('#reviewBtn').hide();
          $('#questionsContent').hide();
          $('#text').hide();
          $('#questionShowWrap').hide();
          $('#quesiton').hide();
          $('#nextStep').fadeIn();

        }, 300);
        this.recordArray[this.getCurrentCorrectOptionIndex()] = 1;

      } else {

        this.questionShow = true;

      }

    });

    /*this.questions = this.getMockData().questions;
    this.currentNumber = 1;*/
  }

  ngAfterViewInit(){

    this.commonService.initPage({
        'backgroundColor':'white'
    });

  }


  onItemClick(i, event){
    let _this = this;
    if(this.selectable){
      // 回答正确
      if(this.optionArray[i] == this.questions[this.currentNumber-1].option){

        this.submitAnswer(i, this.questions[this.currentNumber-1].id);
        this.recordArray[i] = 1;
        $("#question").hide();
        // 显示正确
        // $("#corret").show();
        this.selectable = false;
        this.correctShow = true;
        setTimeout(function(){

          if(_this.currentNumber < _this.questions.length){

            // 只有还需答题才有动画
            _this.questionShow = false;
            setTimeout(function(){

              _this.currentNumber++;
              _this.resetStatus();

            },1000);

          }else{

            _this.recordArray = [0, 0, 0, 0, 0];
            _this.questionShow = false;
            $('#text').fadeOut(200);
            setTimeout(function(){

              $('#nextStep').fadeIn(200);

            }, 500);

          }

        }, 1000);

      }else{

        // 震动
        for(var iter = 0; iter < 6; iter++){

          $(event.target).animate({left:(iter % 2 == 0 ? '-=0.5rem' : '+=0.5rem')}, 100);

        }
        // 回答错误
        this.recordArray[i]=9;
        if(this.checkWrongRecord()){

          this.submitAnswer(i, this.questions[this.currentNumber-1].id);
          this.selectable = false;
          this.recordArray[this.getCurrentCorrectOptionIndex()] = 10;
          setTimeout(function(){

            if(_this.currentNumber < _this.questions.length){

              setTimeout(function(){

                _this.questionShow = false;

              }, 1500);
              setTimeout(function() {

                _this.currentNumber++;
                _this.resetStatus();

              }, 3000);

            }else{

              _this.recordArray = [0, 0, 0, 0, 0];
              _this.questionShow = false;
              $('#text').fadeOut(200);
              setTimeout(function(){

                $('#nextStep').fadeIn(200);

              }, 500);

            } // end of if currentNumber < this.question.lengh

          }, 1000); // end of set timeout

        } // end of checkWrongRecord

      } // end of check option

    } // end of selectable

  } // end of onItemClick

  submitAnswer(i, qid){

    this.apiService.ajax({

      'type':'post',
      'url':'/api/diagnosis/finish',
      'data':{
          'selectors':this.optionArray[i],
          'question_id': qid
      }

    }).subscribe(result=>{});

  } // end of submitAnswer

  resetStatus(){

    this.recordArray = [0, 0, 0, 0, 0];
    this.selectable = true;
    // $("#correct").hide();
    this.questionShow = true;
    // 在滑动后展示问题, 设置正确
    $('#questionWrap').css({"-webkit-transform":"translateX(100%)", "transform":"translateX(100%)"});
    $('#question').show();
    this.correctShow = false;
    $('#questionWrap').css({"-webkit-transform":"translateX(0)","-webkit-transition":"0.5s linear", "transform":"translateX(0)","transition":"0.5s linear"});
  } // end of resetStatus

  checkWrongRecord(){

    return this.recordArray.filter(r => r == 9).length >= 3 ? true : false;

  } // end of checkWrongRecord

  getCurrentCorrectOptionIndex(){

    return this.optionArray.findIndex(o => o == this.questions[this.currentNumber - 1].option);

  } // end of getCurrentCorrectOptionIndex

  goToBegin(){

    this.onGoToBegin.emit(true);
    this.apiService.ajax({
        'type': 'post',
        'url': '/sr/onceino/402',
        'data': {}
    }).subscribe(result => {});

  }

  goToVideo(){

    this.onGoToVideo.emit('question');

  }

  // getMockData(){
  //   return {
  //       "questions": [
  //           {
  //               "id": 1, //题目id
  //               "question": "食物配给出错", //匹配题目
  //               "option": "流程", //匹配答案
  //               "status": 0
  //           },
  //           {
  //               "id": 2,
  //               "question": "小伙伴们觉得团队做的事很Low",
  //               "option": "流程",
  //               "status": 0
  //           },
  //           {
  //               "id": 3,
  //               "question": "有人做事经常没有重点",
  //               "option": "承诺",
  //               "status": 0
  //           },
  //           {
  //               "id": 4,
  //               "question": "说话火药味十足",
  //               "option": "结果",
  //               "status": 0
  //           },
  //           {
  //               "id": 5,
  //               "question": "大家都各自为战，极少配合",
  //               "option": "沟通",
  //               "status": 0
  //           },
  //           {
  //               "id": 6,
  //               "question": "题目6",
  //               "option": "信任",
  //               "status": 0
  //           }
  //       ],
  //       "options": {
  //           "0": "流程",
  //           "2": "承诺",
  //           "3": "结果",
  //           "4": "沟通",
  //           "5": "信任"
  //       },
  //       "status": 0 //是否做完
  //   }
  //
  // }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-team-question/case-practice-team-question.component.ts